module.exports = __webpack_public_path__ + "img/85.9eee0987.png";